let sliders = document.querySelectorAll('.pb-gallery-wrapper');
sliders.forEach(function (galleryWrapper) {
    let gallery = galleryWrapper.querySelector('.pb-gallery');
    let items = galleryWrapper.querySelectorAll('.pb-gallery__item');
    let bullets = galleryWrapper.querySelectorAll('.pb-gallery-bullet');
    let bulletActiveClass = 'pb-gallery-bullet--active';

    bullets.forEach(function (bullet) {
        bullet.addEventListener('click', function () {
            let itemWidth = items[0].offsetWidth;//calculate on event listener to recalculate
            let position = bullet.getAttribute('data-position');
            let offset = (position - 1) * itemWidth;

            gallery.style.transform = 'translateX(-' + offset + 'px)'

            bullets.forEach(function (remove) {
                remove.classList.remove(bulletActiveClass)
            });
            bullet.classList.add(bulletActiveClass);
        });
    });
});